import React from 'react'

const ToastMessageContext = React.createContext()

const ToastMessageContextProvider = ({children}) => {
  const [messages, setMessages] = React.useState([])

  const popMessage = React.useCallback(
    (message, severity = 'info', elRef = null) => {
      const newMessage = {
        message: message,
        severity: severity,
        show: true,
        elRef,
        can_delete: false,
      }
      const nMessages = [
        ...messages.filter(e => e.can_delete === false), // cleanup during addition
        newMessage,
      ]
      setMessages(nMessages)
      // do timeout if has elRef
      if (elRef) {
        setTimeout(() => {
          newMessage.show = false
          setMessages([...nMessages])
        }, 3000)
      }
    },
    [setMessages, messages]
  )

  const handleClose = React.useCallback(
    (event, reason, index) => {
      if (reason === 'clickaway') {
        return
      }
      messages[index].show = false
      setMessages([...messages])
    },
    [setMessages, messages]
  )

  const handleExited = React.useCallback(
    (e, i) => {
      const nMessages = [...messages]
      nMessages[i].can_delete = true
      setMessages(nMessages)
    },
    [messages, setMessages]
  )

  const value = {messages, popMessage, handleClose, handleExited}

  return <ToastMessageContext.Provider value={value}>{children}</ToastMessageContext.Provider>
}

const ToastMessageContextConsumer = ToastMessageContext.Consumer

export {ToastMessageContext, ToastMessageContextProvider, ToastMessageContextConsumer}
